<div class="grid-container wrapper margin-top">
  <div class="grid-x grid-margin-x">
    <div class="cell large-12 text-align-center">
      <h3 class="h4">Applications On Behalf of an Organization</h3>
    </div>
    <div class="cell large-8">
      You are requesting to begin an application on behalf of another organization.<br />
      To begin this process you must have the following:
      <ul class="margin-top">
        <li>A Paper document belonging to an organization known to the Division.</li>
        <li>The organization's RBDMS owner number <span class="bold">OR</span></li>
        <li>The organization's RICS owner number <span class="bold">OR</span></li>
        <li>The organization's full legal name.</li>
      </ul>
    </div>
    <div class="cell large-4">
      <span class="bold">Submission:</span> {{moduleTitle}} <br />
      <span class="bold">Application Type:</span> {{applicationTitle}} <br />
      <span class="bold">Organization:</span> {{organizationName}}<br />
      <span class="bold">Application #:</span> {{applicationNumber}}
    </div>
  </div>
</div>
<div class="wrapper">
  <div class="section-header margin-top" [ngClass]="{ 'active' : currentStep === steps.SelectSubmission }" (click)="setStep(steps.SelectSubmission)">
    Step 1: Select Application Type
    <button (click)="setStep(steps.SelectSubmission)" class="icon-button">
      @if (currentStep !== steps.SelectSubmission) {
        <svg-icon icon="icon-caret-right"></svg-icon>
      }
      @if (currentStep === steps.SelectSubmission) {
        <svg-icon icon="icon-caret-down"></svg-icon>
      }
    </button>
  </div>
  <div class="content-wrapper section-content" [ngStyle]=" { 'display': (currentStep === steps.SelectSubmission) ? 'inherit' : 'none' }">
    <on-behalf-application-select [module]="module" [availableModules]="availableModules" [applicationType]="applicationType" (moduleChanged)="onModuleChanged($event)"
    (applicationChanged)="onApplicationChanged($event)" (nextStep)="advanceStep($event)"></on-behalf-application-select>
  </div>
  <div class="section-header minor-margin-top" [ngClass]="{ 'active' : currentStep === steps.SelectOrganization }" (click)="setStep(steps.SelectOrganization)">
    Step 2: Select Organization
    <button (click)="setStep(steps.SelectOrganization)" class="icon-button">
      @if (currentStep !== steps.SelectOrganization) {
        <svg-icon icon="icon-caret-right"></svg-icon>
      }
      @if (currentStep === steps.SelectOrganization) {
        <svg-icon icon="icon-caret-down"></svg-icon>
      }
    </button>
  </div>
  <div class="content-wrapper section-content" [ngStyle]="{ 'display': (currentStep === steps.SelectOrganization) ? 'inherit' : 'none' }">
    <on-behalf-organization-select (organizationSelected)="onOrganizationSelected($event)" (nextStep)="advanceStep($event)"></on-behalf-organization-select>
  </div>
  <div class="section-header minor-margin-top" [ngClass]="{ 'active': currentStep === steps.GenerateApplicationNumber }" (click)="setStep(steps.GenerateApplicationNumber)">
    Step 3: Generate Application Number
    <button (click)="setStep(steps.GenerateApplicationNumber)" class="icon-button">
      @if (currentStep !== steps.GenerateApplicationNumber) {
        <svg-icon icon="icon-caret-right"></svg-icon>
      }
      @if (currentStep === steps.GenerateApplicationNumber) {
        <svg-icon icon="icon-caret-down"></svg-icon>
      }
    </button>
  </div>
  <div class="content-wrapper section-content margin-top" [ngStyle]="{ 'display' : (currentStep === steps.GenerateApplicationNumber) ? 'inherit' : 'none' }">
    <on-behalf-generate-application [organization]="organization" [applicationType]="applicationType" [applicationModule]="module" (applicationGenerated)="setApplication($event)" (nextStep)="advanceStep($event)" (throwError)="handleError($event)"></on-behalf-generate-application>
  </div>
  <div class="section-header minor-margin-top" [ngClass]="{ 'active': currentStep === steps.GenerateScanAndSubmit }" (click)="setStep(steps.GenerateScanAndSubmit)">
    Step 4: Generate Scanning Sheet and Submit
    <button (click)="setStep(steps.GenerateScanAndSubmit)" class="icon-button">
      @if (currentStep !== steps.GenerateScanAndSubmit) {
        <svg-icon icon="icon-caret-right"></svg-icon>
      }
      @if (currentStep === steps.GenerateScanAndSubmit) {
        <svg-icon icon="icon-caret-down"></svg-icon>
      }
    </button>
  </div>
  <div class="content-wrapper section-content" [ngStyle]="{ 'display': (currentStep === steps.GenerateScanAndSubmit) ? 'inherit': 'none' }">
    <on-behalf-scanning-document [applicationNumber]="applicationNumber" [applicationType]="urlComponent" (cancelRequest)="routeHome()" [organization]="organization" (applicationSubmitted)="applicationSubmitted()" (throwError)="handleError($event)" ></on-behalf-scanning-document>
  </div>
</div>
<a style="display: none;" href="" target="_blank" #downloadLink>Download</a>